import React from 'react';
import { Link } from 'react-router-dom';

export default function MenuWidget({ data }) {
  return (
    <>
   <h4> Quick Links</h4>
    <ul className="cs_menu_widget cs_mp0 mt-4">
       
      {data?.map((item, index) => (
        <li key={index}>
          <Link to={item.href}>{item.title}</Link>
        </li>
      ))}
    </ul>
    </>
  );
}
